module.exports = __webpack_public_path__ + "static/scale-model-of-stiern-park-in-bakersfield-california-d64b57b02709ea588290637a5457c544.png";